<div [class]="tabClass">
    <mat-tab-group [@.disabled]="true" [selectedIndex]="selectIndex" [mat-stretch-tabs]="isMatStretchTabs" (selectedTabChange)=callback.emit($event)>
        @for (config of tabArray; track config) {
        <mat-tab>
            <ng-template mat-tab-label>
                @if (config.showNum) {
                <span class="count-num">{{config.countNum}}</span>
                }
                <span>@if (config.showIcon) {
                    <i class="{{config.iconClass}} font-16 mr-5 d-inline-block align-middle"></i>
                    }
                    <span class="d-inline-block align-middle"> {{config.titile}}</span>
                    @if (config.showRightIcon) {
                    <i class="{{config.rightIconClass}} font-16 mr-5 d-inline-block align-middle"></i>
                    }
                </span>
            </ng-template>
            <ng-container [ngTemplateOutlet]="dataTemplate" [ngTemplateOutletContext]="{  $implicit: config }">
            </ng-container>
        </mat-tab>
        }
    </mat-tab-group>
</div>


